import {Component, OnInit} from '@angular/core';
import {ROUTES} from './app.routes';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit
{
    ngOnInit(): void
    {
        console.log('LOGIN Route ' + ROUTES.SECURE.HOME.VIEW);
    }
}